import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button} from "react-bootstrap";
import APICom from "../../utils/helpers/APICom";
import ConfirmationModal from "../Controls/ConfirmationModal";
import { HotKeys } from "react-hotkeys";
import { configure } from "react-hotkeys";
configure({
    ignoreTags: []
});

const ForceDispatch = (props) => {

    const { loginData } = useSelector((store) => store.login);
    const { ASCSSettingData }  = useSelector((store) => store.combinedata);
    const [isComponentLoading, setIsComponentLoading] = useState(true);
    const [showAlert, setAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({alertTitle: '', alertMsg:''});
    const [dispatchMethod, setDispatchMethod] = useState(0);
    const [bRestrictedAccountDispatch, setRestrictedAccountDispatch] = useState('false');
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Restricted Driver Assignment',
    body:'Driver has been restricted from performing trips for this Funding Source. Are you sure you want to continue with dispatch?', btnCanceText: 'No',
    btnOkText: 'Yes'});
    
    useEffect(() => {
      if(props.GridRowData === null || props.GridRowData.length <= 0)
      {
        setAlertObj({...alertObj, alertTitle: 'No trip selected', alertMsg:'No request selected to perform force dispatch.'});
        setAlert(true);
      }
      else
      {
        const gData = props.GridRowData[0];
        /*if(gData.CreatedBy === "(ExternalDispatch)")
        {
            setAlertObj({...alertObj, alertTitle: 'Action Restriction', alertMsg: "Action is not allowed for external trip."});
            setAlert(true);
        }
        else */if(gData.TableSource !== "FromOnDemandTable")
        {
            setAlertObj({...alertObj, alertTitle: 'Action Failed', alertMsg: "Force dispatch can only be performed for ondemand trips."});
            setAlert(true);
        }
        else if(gData.ServiceStatus.toLowerCase() === "active" || gData.ServiceStatus.toLowerCase() === "dispatched" || gData.ServiceStatus.toLowerCase() === "assigned")
        {
            

            if ((props.selectedVehicle == "" || parseInt(props.selectedVehicle) <= 0) && (dispatchMethod == 0 || dispatchMethod == 2)) {
                setAlertObj({...alertObj, alertTitle: 'Action Failed', alertMsg: "Please select the vehicle."});
                setAlert(true);
            }
            if ((props.selectedDriver == "" || parseInt(props.selectedDriver) <= 0) && (dispatchMethod == 1 || dispatchMethod == 2)) {
                setAlertObj({...alertObj, alertTitle: 'Action Failed', alertMsg: "Please select the driver."});
                setAlert(true);
            }

            if (parseInt(props.selectedVehicle) <= 0 && (dispatchMethod == 0 || dispatchMethod == 2) ) {
                  setAlertObj({...alertObj, alertTitle: 'Action Failed', alertMsg: "Please select the vehicle."});
                  setAlert(true);
            }
            else if (parseInt(props.selectedDriver) <= 0 && (dispatchMethod == 1 || dispatchMethod == 2)) {
                  setAlertObj({...alertObj, alertTitle: 'Action Failed', alertMsg: "Please select the driver."});
                  setAlert(true);
            }
            else
            {
              if(ASCSSettingData !== null && ASCSSettingData !== undefined)
              {
                  if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
                      const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
                      for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                      {
                          if(ascsSettingDataByAffiliate[i]["SubTitle"] === "DispatchMethod")
                          {
                              setDispatchMethod(ascsSettingDataByAffiliate[i]["value"]);
                          }
                          if(ascsSettingDataByAffiliate[i]["SubTitle"] === "bRestrictedAccountDispatch")
                          {
                            setRestrictedAccountDispatch(ascsSettingDataByAffiliate[i]["value"]);
                            PerformForcedDispatch('false')
                            
                          }
                      }
                  }
              }
            } 
        }
        else
        {
           setAlertObj({...alertObj, alertTitle: 'Invalid Trip State', alertMsg: "'" + gData.ConfirmationNo + "' cannot be forced dispatched."});
           setAlert(true);
        }
      }
    }, []);

    // useEffect(() => {
    //     PerformForcedDispatch('false');
    // }, [bRestrictedAccountDispatch]);


    const PerformForcedDispatch = async (SkipDriverRestrictionProcess) => {
      const gData = props.GridRowData[0];
      var Param = {
        "iServiceID": gData.ServiceID.toString(),
        "iAssignedVehicleId": (parseInt(props.selectedVehicle) <= 0 && (dispatchMethod == 1)) ? "-1": props.selectedVehicle.toString(),
        "AssignedDriverId": (parseInt(props.selectedDriver) <= 0 && (dispatchMethod == 0)) ? "-1" : props.selectedDriver.toString(),
        "iFundingSourceID": gData.iFundingSourceID.toString(),
        "iATSPID": gData.iSRATSPID.toString(),
        "SkipDriverRestrictionProcess": SkipDriverRestrictionProcess.toString(),
        "bOnlyPreferedVehicle": props.chkVehicleRequiredRef.toString(),
        "iUserID": loginData.iUserID,
        "iAppID": "26",
        "bRestrictedAccountDispatch": bRestrictedAccountDispatch.toString()

      }
      let response = await APICom.fetchData("", "TripActions/PerformForceDispatch", "post", { "Content-Type": "application/json" }, Param, null);
      let result = response.data;
      if(result == "Success")
      {
        setAlertObj({...alertObj, alertTitle: 'Forced Dispatch Action', alertMsg: "Action performed successfully."});
        setAlert(true);
      }
      else if(result == "Retricted")
      {
        setConfirmationModalObj((prevState) => ({...prevState, show:true}));
      }
      else
      {
        setAlertObj({...alertObj, alertTitle: 'Forced Dispatch Failed', alertMsg: "Action failed."});
        setAlert(true);
      }
    }

  const handleConfirmationModalOk = () => {
    setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    PerformForcedDispatch('true');
  }

  const handleConfirmationModalCancel = () => {
    setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    UnMountForceDispatchComponent();
  }

    const handleAlertClose = () => {
        setAlert(false);
        UnMountForceDispatchComponent();
      }
    
      const UnMountForceDispatchComponent = () => {
        if(props.invokeForceDispatch)
        {
          props.RefreshGridData();
          props.setForceDispatchObj((prevState) => ({...prevState, invokeForceDispatch: false, isForceDispatchProcessing: false}));
        }
      }


      const keyMap = {
        ALT_F: 'alt+f',
        CLOSE_MODAL: 'esc',
    }

    const handleHotKeys = {
      ALT_F: (event) => {
        event.preventDefault();
      },
      CLOSE_MODAL:(event) => {
        event.preventDefault();
        handleAlertClose()
      },
      
  };

    return(
        <>
        <HotKeys keyMap={keyMap} handlers={handleHotKeys}></HotKeys>
            { showAlert && <Modal centered show={showAlert} onHide={handleAlertClose} animation={false} >
                                  <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                                    <Modal.Title className='activate_dialog_title_color'>{alertObj.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{alertObj.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleAlertClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>}
                <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                                   onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} btnCanceText={confirmationModalObj.btnCanceText}
                                   btnOkText={confirmationModalObj.btnOkText} />
        </>
    );
};


export default ForceDispatch;